var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCharging(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1956 15.2706C21.2099 14.3087 21.9384 13.0693 22.2961 11.6969C22.6539 10.3245 22.6261 8.87554 22.2162 7.51876C21.8062 6.16198 21.0309 4.95324 19.9805 4.03333C18.9301 3.11341 17.6479 2.52019 16.2832 2.32274C14.9185 2.12529 13.5275 2.33176 12.2722 2.91808C11.0169 3.50441 9.94892 4.44646 9.19274 5.63452C8.43655 6.82258 8.02324 8.20774 8.00095 9.62868C7.97866 11.0496 8.3483 12.4478 9.06682 13.6605L10.0482 13.0421C9.44334 12.0212 9.13215 10.8441 9.15092 9.64787C9.16969 8.45164 9.51763 7.28552 10.1542 6.28534C10.7908 5.28517 11.6899 4.49209 12.7467 3.99849C13.8035 3.50489 14.9745 3.33107 16.1234 3.4973C17.2723 3.66352 18.3517 4.16293 19.236 4.93737C20.1203 5.71181 20.773 6.72939 21.1181 7.87161C21.4633 9.01383 21.4866 10.2337 21.1854 11.389C20.8843 12.5444 20.271 13.5878 19.4171 14.3976L20.1956 15.2706Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5455 9.75H9.09091V10.5H10.5455V9.75Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9091 4.875V3.375H15.6364V4.875H14.9091Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.5H21.4545V9.75H20V10.5Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5455 13.5L19.6364 14.625L21.4545 16.5H18.5455V13.5Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.54545 12.75H15.6364V15.375H16.7273V18.75H15.6364V21.375H2.54545V18.75H1.45454V15.375H2.54545V12.75ZM3.63636 20.25V13.875H14.5455V20.25H3.63636ZM4.36363 14.625H6.90909V19.5H4.36363V14.625ZM7.63636 14.625V19.5H10.1818V14.625H7.63636ZM10.9091 14.625V19.5H13.4545V14.625H10.9091Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.0727273
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.2727,
    cy: 9.75,
    rx: 0.727273,
    ry: 0.75,
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2541 6.6703C13.164 6.48934 13.2357 6.26594 13.4144 6.17132V6.17132C13.593 6.07669 13.8109 6.14667 13.901 6.32763L15.7316 10.0028L15.0846 10.3455L13.2541 6.6703Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4345 8.71538C18.6378 8.67713 18.8319 8.81129 18.8679 9.01503V9.01503C18.904 9.21877 18.7684 9.41495 18.565 9.45321L15.3825 10.0519L15.252 9.3141L18.4345 8.71538Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharging);
export default __webpack_public_path__ + "static/media/charging.9baaa0a8f6d4321b176d8c771da9b0a3.svg";
export { ForwardRef as ReactComponent };